export const SAVE_SUBSTITUTION_MODAL = 'substitution';
